const pad = (n) => String(n).padStart(2, "0");

export const toLocalDateTimeMin = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00`;
};

export const isDateExpired = (date) => {
    return date && new Date(date) < new Date()
}

export const isDateBeforeMin = (date, min) => {
    return date && min && new Date(date) < new Date(min)
};
